import { render, staticRenderFns } from "./NewTHGTag.vue?vue&type=template&id=e4d4a826"
import script from "./NewTHGTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewTHGTag.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports